import { useState } from 'react';

import UpdateBanner from './UpdateBanner';
import { cn } from '@cobliteam/ui/utils';
import { useRegisterSW } from 'virtual:pwa-register/react';

import { Analytics } from '@cobliteam/analytics';
import { DatadogTrack } from '@cobliteam/datadog-rum';

import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';

const SidebarUpdate = ({ sidebarOpen }: { sidebarOpen: boolean }) => {
  const [needUpdate, setNeedUpdate] = useState(false);
  const { herbieDashboardVersion } = useFeatureFlags();

  useRegisterSW({
    onRegisterError(error) {
      Analytics.track('Service Worker Register Error');
      DatadogTrack.error(error);
    },
    onRegisteredSW(swUrl, registration) {
      Analytics.track('Service Worker Register Success', { swUrl });
      if (registration) {
        registration.onupdatefound = () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.onstatechange = () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // Nova atualização disponível
                  setNeedUpdate(true);
                }
              }
            };
          }
        };
      }
    },
  });

  const handleUpdate = () => {
    Analytics.track('Update Sidebar Refresh Clicked');
    window.location.reload();
  };

  if (needUpdate)
    return (
      <>
        <UpdateBanner />
        <div className='my-2 flex px-4 pr-2'>
          <button type='button' onClick={handleUpdate} className='flex items-center text-xs hover:underline'>
            <span className={cn('start-7 top-0 mr-2 size-1.5 rounded-full bg-warning-11')} />
            {sidebarOpen ? `Nova versão disponível - ${herbieDashboardVersion}` : window.__DASHBOARD_MONOREPO_VERSION__}
          </button>
        </div>
      </>
    );

  return (
    <div className='my-2 flex items-center px-4 pr-2 text-xs'>
      <span className='start-7 top-0 mr-2 size-1.5 rounded-full border-2 border-success bg-success' />
      {sidebarOpen ? ` Versão - ${window.__DASHBOARD_MONOREPO_VERSION__}` : window.__DASHBOARD_MONOREPO_VERSION__}
    </div>
  );
};

export default SidebarUpdate;
